<!--<div class="ui-rtl" dir="rtl">-->
<!--  <p-menubar [model]="siteMenu" styleClass="site-menu">-->
<!--    <ng-template pTemplate="end">-->
<!--     <div class="user-login-register" *ngIf="!user.isLoggedIn" style="color: white">-->
<!--       התחבר \ הירשם-->
<!--     </div>-->
<!--    </ng-template>-->
<!--  </p-menubar>-->

<!--</div>-->

<!--<div class="site-menu-wrapper" style="min-height: 64px" fxLayout="row" fxShow.lt-md="false">-->
<!--  <div class="site-menu-container" fxLayout="row" fxLayoutGap="2em"-->
<!--       fxLayoutAlign.lt-md="flex-start"-->
<!--       fxLayoutGap.lt-md="0">-->
<!--    <div-->
<!--      class="menu-item"-->
<!--      fxFlex=""-->
<!--      style="cursor: pointer"-->
<!--      [routerLink]="item.routerLink"-->
<!--      fxLayoutAlign.lt-md="flex-start"-->
<!--      *ngFor="let item of siteMenu" fxLayout="row" fxLayoutGap=".5em" fxFlexAlign="center" fxLayoutAlign=" center">-->
<!--      <fa-icon [icon]="item.fa_icon" *ngIf="item.fa_icon"></fa-icon>-->
<!--      <span>{{item.label}}</span>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<div class="site-menu-wrapper">
  <div class="show-x" fxShow.gt-sm="false" fxLayout="row" fxLayoutGap=".5em" fxLayoutAlign="flex-start"
    style="color:white" (click)="closeMenu()">
    <fa-icon [icon]="faChevronRight"></fa-icon>
    <span *ngIf="!isUAERoute">{{ 'MENU.BACK' | translate }}</span>
    <span *ngIf="isUAERoute">{{ 'MENU.BACK' | translate }}</span>
  </div>
  <h3 fxShow.gt-sm="false" style="padding-bottom: .5em;border-bottom: 1px solid whitesmoke;color:white" *ngIf="!isUAERoute">{{ 'MENU.MENU' | translate }}</h3>
  <h3 fxShow.gt-sm="false" style="padding-bottom: .5em;border-bottom: 1px solid whitesmoke;color:white" *ngIf="isUAERoute">{{ 'MENU.MENU' | translate }}</h3>

  <!-- Nigeria market: English-only public page — offer Login / Register in the mobile menu only
       (desktop uses the header's own Login/Register buttons, so this is mobile-only to avoid duplicates) -->
  <div *ngIf="isNigeriaRoute && !user.isLogin" class="user-login-mobile" fxLayout="column" fxLayoutGap="1em"
       fxHide="true" fxHide.lt-md="false" style="padding: 1em 15px 0; color: white;">
    <div class="menu-item" fxLayout="row" fxLayoutGap="1em" routerLink="/auth/login" (click)="closeMenu()">
      <i class="fas fa-sign-in-alt"></i>
      <span>{{ 'HEADER.LOGIN' | translate }}</span>
    </div>
    <div class="menu-item" fxLayout="row" fxLayoutGap="1em" routerLink="/auth/register" (click)="closeMenu()">
      <i class="fas fa-user-plus"></i>
      <span>{{ 'HEADER.SIGNUP' | translate }}</span>
    </div>
  </div>

  <div *ngIf="!isUAERoute" class="site-menu-container" fxLayoutGap="1em" fxLayout="row" fxLayoutAlign.gt-sm="start center"
    fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="flex-start"
    style="min-height: 64px;padding-right: 15px;">
    <div class="menu-item" *ngFor="let item of siteMenu" [routerLink]="item.routerLink" fxLayout="row"
      fxLayoutGap="1.5em">
      <ng-container *ngIf="item.fa_icon  && item.routerLink == '/' && displayElement">
        <fa-icon [icon]="item.fa_icon" fxFlex.lt-md="10%"></fa-icon>
        <span [ngStyle]="{ 'color': item.color, 'fontWeight': item.weight}">{{item.label}}</span>
      </ng-container>
      <ng-container
        *ngIf="item.fa_icon && (item.routerLink != '/' && item.routerLink != '/cars' && item.routerLink != '/car-market' && item.routerLink != '/account/calculate' && item.routerLink != '/cert-check')">
        <fa-icon [icon]="item.fa_icon" fxFlex.lt-md="10%"></fa-icon>
        <span [ngStyle]="{ 'color': item.color, 'fontWeight': item.weight}">{{item.label}}</span>
      </ng-container>
      <ng-container *ngIf="item.routerLink == '/account/basic-order' && authenticated()">
        <fa-icon [icon]="item.fa_icon" fxFlex.lt-md="10%"></fa-icon>
        <span [ngStyle]="{ 'color': item.color, 'fontWeight': item.weight}">{{item.label}}</span>
      </ng-container>
      <ng-container *ngIf="item.routerLink == '/account/calculate' && authenticated() && localeService.israeliMarket">
        <fa-icon [icon]="item.fa_icon" fxFlex.lt-md="10%"></fa-icon>
        <span [ngStyle]="{ 'color': item.color, 'fontWeight': item.weight}">{{item.label}}</span>
      </ng-container>
      <ng-container *ngIf="item.routerLink == '/cars' && authenticated() && hasRole('commercial_importer')">
        <fa-icon [icon]="item.fa_icon" fxFlex.lt-md="10%"></fa-icon>
        <span [ngStyle]="{ 'color': item.color, 'fontWeight': item.weight}">{{item.label}}</span>
      </ng-container>
      <ng-container
        *ngIf="item.routerLink == '/car-market' && authenticated() && !hasRole('commercial_importer') && (hasRole('personal_importer_mediator') || hasRole('personal_importer'))">
        <fa-icon [icon]="item.fa_icon" fxFlex.lt-md="10%"></fa-icon>
        <span [ngStyle]="{ 'color': item.color, 'fontWeight': item.weight}">{{item.label}}</span>
      </ng-container>
      <ng-container
        *ngIf="item.routerLink == '/cert-check' && authenticated() && hasRole('commercial_importer') && !forUae() && localeService.israeliMarket">
        <fa-icon [icon]="item.fa_icon" fxFlex.lt-md="10%"></fa-icon>
        <span [ngStyle]="{ 'color': item.color, 'fontWeight': item.weight}">{{item.label}}</span>
      </ng-container>
    </div>
    <div class="beamerTrigger" *ngIf="hasRole('commercial_importer')" style="color:white">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i style="font-size: 16px;" class="fa fa-bullhorn" aria-hidden="true"></i>
    </div>

    <div class="user-login-mobile" fxLayout="column" fxLayoutGap="1em" fxHide="true" fxHide.lt-md="false"
      *ngIf="user.isLogin">
      <h3 style="padding-bottom: .25em;color: white;border-bottom: 1px solid whitesmoke">{{ 'MENU.MY_ACCOUNT' | translate }}</h3>
      <div class="menu-item" fxLayout="row" fxLayoutGap="1em" [routerLink]="['/','account', 'orders']">
        <fa-icon [icon]="faSuiteCase" fxFlex.lt-md="10%"></fa-icon>
        <span>{{ 'MENU.CLIENT_FILE' | translate }}</span>
      </div>
      <div class="menu-item" fxLayout="row" fxLayoutGap="1em" [routerLink]="['/','account','calculate']">
        <fa-icon [icon]="faPlus" fxFlex.lt-md="10%"></fa-icon>
        <span>{{ 'MENU.NEW_ORDER' | translate }}</span>
      </div>
      <div class="menu-item" fxLayout="row" fxLayoutGap="1em" [routerLink]="['/','account','orders']">
        <fa-icon [icon]="faCopy" fxFlex.lt-md="10%"></fa-icon>
        <span>{{ 'MENU.MY_ORDERS' | translate }}</span>
      </div>
      <!--        <div *ngIf="user?.userData?.role?.includes('commercial_importer')" class="menu-item" fxLayout="row" fxLayoutGap="1em" [routerLink]="['/','cars']">-->
      <!--          <fa-icon [icon]="faSuiteCase"  fxFlex.lt-md="10%"></fa-icon>-->
      <!--          <span>רכבים זמינים לרכישה</span>-->
      <!--        </div>-->
      <!--        <div *ngIf="!hasRole('commercial_importer') && hasRole('personal_importer')" class="menu-item" fxLayout="row" fxLayoutGap="1em" [routerLink]="['/','car-market']">-->
      <!--          <fa-icon [icon]="faSuiteCase"  fxFlex.lt-md="10%"></fa-icon>-->
      <!--          <span>רכבים זמינים לרכישה</span>-->
      <!--        </div>-->
      <div class="menu-item" fxLayout="row" fxLayoutGap="1em" [routerLink]="['/','cars', 'my-list']">
        <fa-icon [icon]="faCar" fxFlex.lt-md="10%"></fa-icon>
        <span>{{ 'MENU.MY_VEHICLES' | translate }}</span>
      </div>
      <div class="menu-item" fxLayout="row" fxLayoutGap="1em" (click)="logout()">
        <fa-icon [icon]="faSignOut" fxFlex.lt-md="10%"></fa-icon>
        <span>{{ 'MENU.DISCONNECT' | translate }}</span>
      </div>
    </div>

  </div>
</div>
